import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCrmCustomerRewardBalanceMeResponse, transformCustomerRewardHistoryMeResponse, transformSalesCartRewardBalanceMeResponse, transformSalesCartRewardThresholdMeResponse, transformCrmCustomerRewardSubscriptionMeResponse, transformPutCrmCustomerRewardSubscriptionMeResponse, transformPostSalesCartRewardResponse, transformDeleteSalesCartReward } from './transformers.js';
import defaultClient from 'axios';

const getCrmCustomerRewardBalanceMe = async ({ client , controller  } = {})=>await client.get(`V1/crm/customer/reward/balance/me`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerRewardBalanceMeResponse)
        ]
    });
getCrmCustomerRewardBalanceMe.key = 'getCrmCustomerRewardBalanceMe';
const getCrmCustomerRewardHistoryMe = async ({ client , controller , limit =1000000 , offset =0  } = {})=>await client.get(`V1/crm/customer/reward/history/me`, {
        signal: controller?.signal,
        params: {
            filter: {
                limit,
                offset
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCustomerRewardHistoryMeResponse)
        ]
    });
getCrmCustomerRewardHistoryMe.key = 'getCrmCustomerRewardHistoryMe';
const getSalesCartRewardBalanceMe = async ({ client , controller  } = {})=>await client.get(`V1/sales/cart/reward/balance/me`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCartRewardBalanceMeResponse)
        ]
    });
getSalesCartRewardBalanceMe.key = 'getSalesCartRewardBalanceMe';
const getSalesCartRewardThresholdMe = async ({ client , controller  } = {})=>await client.get(`V1/sales/cart/reward/threshold/me`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCartRewardThresholdMeResponse)
        ]
    });
getSalesCartRewardThresholdMe.key = 'getSalesCartRewardThresholdMe';
const getCrmCustomerRewardSubscriptionMe = async ({ client , controller  } = {})=>await client.get(`V1/crm/customer/reward/subscription/me`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerRewardSubscriptionMeResponse)
        ]
    });
getCrmCustomerRewardSubscriptionMe.key = 'getCrmCustomerRewardSubscriptionMe';
const putCrmCustomerRewardSubscriptionMe = async ({ client , controller , warningNotification , updateNotification  })=>await client.put(`V1/crm/customer/reward/subscription/me`, {
        reward_warning_notification: warningNotification,
        reward_update_notification: updateNotification
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPutCrmCustomerRewardSubscriptionMeResponse)
        ]
    });
putCrmCustomerRewardSubscriptionMe.key = 'putCrmCustomerRewardSubscriptionMe';
const postSalesCartReward = async ({ client , controller , code  })=>await client.post(`V1/sales/cart/reward/${code}`, null, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPostSalesCartRewardResponse)
        ]
    });
postSalesCartReward.key = 'postSalesCartReward';
const deleteSalesCartReward = async ({ client , controller  } = {})=>await client.delete(`V1/sales/cart/reward`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformDeleteSalesCartReward)
        ]
    });
deleteSalesCartReward.key = 'deleteSalesCartReward';

export { deleteSalesCartReward, getCrmCustomerRewardBalanceMe, getCrmCustomerRewardHistoryMe, getCrmCustomerRewardSubscriptionMe, getSalesCartRewardBalanceMe, getSalesCartRewardThresholdMe, postSalesCartReward, putCrmCustomerRewardSubscriptionMe };
